export const INITIAL_DATA = "INITIAL_DATA";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const PORTAL_LOGIN = "PORTAL_LOGIN";
export const CREATE_NEW_PASSWORD = "CREATE_NEW_PASSWORD";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const ACTIVE_MENU = "ACTIVE_MENU";
export const ANALYTICS_STATUS = "ANALYTICS_STATUS";
export const ANALYTICS_DIVISION = "ANALYTICS_DIVISION";
export const ANALYTICS_PRODUCT = "ANALYTICS_PRODUCT";
export const ANALYTICS_FIELD_FORCE = "ANALYTICS_FIELD_FORCE";
export const ANALYTICS_DISTRIBUTOR = "ANALYTICS_DISTRIBUTOR";
export const ANALYTICS_PHARMACY = "ANALYTICS_PHARMACY";
export const ANALYTICS_DOCTOR = "ANALYTICS_DOCTOR";
export const ANALYTICS_HEADQUATER = "ANALYTICS_HEADQUATER";

export const PRIVACY_POLICY = "PRIVACY_POLICY";
export const TERMS_CONDITION = "TERMS_CONDITION";
export const STATE_LIST = "STATE_LIST";
export const DISTRICT_LIST = "DISTRICT_LIST";
export const CITY_LIST = "CITY_LIST";
export const DIVISION_LIST = "DIVISION_LIST";
export const FETCH_HEADQUATER_LIST = "FETCH_HEADQUATER_LIST";
export const FETCH_DOCTOR_LIST = "FETCH_DOCTOR_LIST";
export const FETCH_PHARMACY_LIST = "FETCH_PHARMACY_LIST";
export const FETCH_ADD_DOCTOR_LIST = "FETCH_ADD_DOCTOR_LIST";
export const FETCH_ADD_PHARMACY_LIST = "FETCH_ADD_PHARMACY_LIST";
export const PRODUCT_ADD_DOCTOR = "PRODUCT_ADD_DOCTOR";
export const PRODUCT_ADD_PHARMACY = "PRODUCT_ADD_PHARMACY";
export const PRODUCT_VIEW_DOCTOR_LIST = "PRODUCT_VIEW_DOCTOR_LIST";
export const PRODUCT_VIEW_PHARMACY_LIST = "PRODUCT_VIEW_PHARMACY_LIST";
export const PRODUCT_DOCTOR_OFFERS_REQUEST = "PRODUCT_DOCTOR_OFFERS_REQUEST";
export const PRODUCT_PHARMACY_OFFERS_REQUEST =
  "PRODUCT_PHARMACY_OFFERS_REQUEST";
export const FETCH_DISTRIBUTOR_DISTRICTS = "FETCH_DISTRIBUTOR_DISTRICTS";
export const DISTRIBUTOR_DISTRICT_EDIT = "DISTRIBUTOR_DISTRICT_EDIT";
export const PACKING_TYPE = "PACKING_TYPE";
export const PRODUCT_LIST = "PRODUCT_LIST";
export const PRODUCT_DETAIL = "PRODUCT_DETAIL";
export const PRODUCT_CREATE = " PRODUCT_CREATE";
export const PRODUCT_EDIT = " PRODUCT_EDIT";
export const PRODUCT_ENABLE_DESABLE = " PRODUCT_ENABLE_DESABLE";
export const PRODUCT_DELETE = " PRODUCT_DELETE";
export const PRODUCT_VERSION_LIST = " PRODUCT_VERSION_LIST";
export const PRODUCT_VERSION_DETAIL = " PRODUCT_VERSION_DETAIL";
export const VENDOR_DIVISION_LIST = " VENDOR_DIVISION_LIST";
export const SEND_MAIL = " SEND_MAIL";
export const DISTRIBUTOR_DIVISION_LIST = " DISTRIBUTOR_DIVISION_LIST";
export const CREATE_DISTRIBUTOR = " CREATE_DISTRIBUTOR";

export const DIVISION_MANU_LIST = "DIVISION_MANU_LIST";
export const DIVISION_DETAIL_MANU_LIST = "DIVISION_DETAIL_MANU_LIST";
export const PRODUCT_DIVISION_LIST = "PRODUCT_DIVISION_LIST";
export const FIELDFORCE_DIVISION_LIST = "FIELDFORCE_DIVISION_LIST";
export const DOCTOR_DIVISION_LIST = "DOCTOR_DIVISION_LIST";
export const DOCTOR_CREATE = "DOCTOR_CREATE";
export const PHARMACY_CREATE = "PHARMACY_CREATE";
export const PHARMACY_DIVISION_LIST = "PHARMACY_DIVISION_LIST";
export const DOCTOR_DIV_VIEW = "DOCTOR_DIV_VIEW";
export const PHARMACY_DIV_VIEW = "PHARMACY_DIV_VIEW";
export const REIMBURSEMENT_LIST = "REIMBURSEMENT_LIST";
export const CREATE_DIVISION = "CREATE_DIVISION";
export const EDIT_DIVISION = "EDIT_DIVISION";
export const ENABLE_DISABLE_DIVISION = "ENABLE_DISABLE_DIVISION";
export const PRODUCT_BULK_VERIFY = "PRODUCT_BULK_VERIFY";
export const PRODUCT_CSV_UPLOAD = "PRODUCT_CSV_UPLOAD";
export const FIELD_FORCE_CSV_UPLOAD = "FIELD_FORCE_CSV_UPLOAD";
export const FIELD_FORCE_BULK_VERIFY = "FIELD_FORCE_BULK_VERIFY";
export const DISTRIBUTOR_CSV_UPLOAD = "DISTRIBUTOR_CSV_UPLOAD";
export const DISTRIBUTOR_BULK_VERIFY = "DISTRIBUTOR_BULK_VERIFY";
export const DOCTOR_CSV_UPLOAD = "DOCTOR_CSV_UPLOAD";
export const DOCTOR_BULK_VERIFY = "DOCTOR_BULK_VERIFY";
export const PHARMACY_CSV_UPLOAD = "PHARMACY_CSV_UPLOAD";
export const PHARMACY_BULK_VERIFY = "PHARMACY_BULK_VERIFY";

export const CREATE_FIELD_FORCE = "CREATE_FIELD_FORCE";
export const DESIGNATION_LIST = "DESIGNATION_LIST";
export const REPORTING_MANAGER_LIST = "REPORTING_MANAGER_LIST";
export const HEAD_QUATERS_LIST = "HEAD_QUATERS_LIST";
export const FIELD_FORCE_LIST = "FIELD_FORCE_LIST";
export const FIELD_FORCE_VERSION_LIST = "FIELD_FORCE_VERSION_LIST";
export const FIELD_FORCE_VERSION_DETAIL = "FIELD_FORCE_VERSION_DETAIL";
export const FIELD_FORCE_DETAIL = "FIELD_FORCE_DETAIL";
export const EDIT_FIELD_FORCE = "EDIT_FIELD_FORCE";
export const DELETE_FIELD_FORCE = "DELETE_FIELD_FORCE";
export const ENALBE_DISABLE_FIELD_FORCE = "ENALBE_DISABLE_FIELD_FORCE";

export const FIELD_FORCE_HEADQUARTER_LIST = "FIELD_FORCE_HEADQUARTER_LIST";
export const FIELD_FORCE_HEADQUARTER_DETAIL = "FIELD_FORCE_HEADQUARTER_DETAIL";
export const FIELD_FORCE_HEADQUARTER_CREATE = "FIELD_FORCE_HEADQUARTER_CREATE";
export const FIELD_FORCE_HEADQUARTER_EDIT = "FIELD_FORCE_HEADQUARTER_EDIT";
export const FIELD_FORCE_HEADQUARTER_VERSION_LIST =
  "FIELD_FORCE_HEADQUARTER_VERSION_LIST";
export const FIELD_FORCE_HEADQUARTER_VERSION_DETAIL =
  "FIELD_FORCE_HEADQUARTER_VERSION_DETAIL";
export const ENABLE_DISABLE_HEADQUARTER = "ENABLE_DISABLE_HEADQUARTER";
export const FIELD_FORCE_HEADQUARTER_DELETE = "FIELD_FORCE_HEADQUARTER_DELETE";
export const FIELD_FORCE_ADMIN_DETAIL = "FIELD_FORCE_ADMIN_DETAIL";
export const FIELD_FORCE_ADMIN_OVERRIDE = "FIELD_FORCE_ADMIN_OVERRIDE";
export const FIELD_FORCE_ADMIN_VERIFY_DETAIL =
  "FIELD_FORCE_ADMIN_VERIFY_DETAIL";
export const FIELD_FORCE_ADMIN_EDIT_DETAIL = "FIELD_FORCE_ADMIN_EDIT_DETAIL";
export const REPORT_DESIGNATION_LIST = "REPORT_DESIGNATION_LIST";
export const SUBORDINATES_LIST = "SUBORDINATES_LIST";
export const REPORTING_FIELD_FORCE_LIST = "REPORTING_FIELD_FORCE_LIST";
export const UPDATE_SUBORDINATES_REPORTING_MANAGER =
  "UPDATE_SUBORDINATES_REPORTING_MANAGER";
export const UPDATE_CUSTOMERS_REPORTING_MANAGER =
  "UPDATE_CUSTOMERS_REPORTING_MANAGER";
export const FF_CUSTOMERS_LIST = "FF_CUSTOMERS_LIST";

export const FETCH_DESIGNATION_LIST = "FETCH_DESIGNATION_LIST";
export const FETCH_DESIGNATION_DETAIL = "FETCH_DESIGNATION_DETAIL";
export const FIELD_FORCE_DESIGNATION_CREATE = "FIELD_FORCE_DESIGNATION_CREATE";
export const FIELD_FORCE_DESIGNATION_EDIT = "FIELD_FORCE_DESIGNATION_EDIT";
export const FIELD_FORCE_DESIGNATION_DELETE = "FIELD_FORCE_DESIGNATION_DELETE";
export const FIELD_FORCE_DESIGNATION_VERSION_LIST =
  "FIELD_FORCE_DESIGNATION_VERSION_LIST";
export const FIELD_FORCE_DESIGNATION_VERSION_DETAIL =
  "FIELD_FORCE_DESIGNATION_VERSION_DETAIL";
export const LINK_EMP_LIST = "LINK_EMP_LIST";
export const LINK_EMPLOYEE = "LINK_EMPLOYEE";
export const CUSTOMER_LIST = "CUSTOMER_LIST";
export const CUSTOMER_PHARMACY_LIST = "CUSTOMER_PHARMACY_LIST";
export const CUSTOMER_PHARMACY_DETAIL = "CUSTOMER_PHARMACY_DETAIL";
export const CUSTOMER_DETAIL = "CUSTOMER_DETAIL";
export const SUBSCRIBER_REQUEST_LIST = "SUBSCRIBER_REQUEST_LIST";
export const SUBSCRIBER_REQUEST_DETAIL = "SUBSCRIBER_REQUEST_DETAIL";
export const SUBSCRIBER_REQUEST_PHARMACY_LIST =
  "SUBSCRIBER_REQUEST_PHARMACY_LIST";
export const SUBSCRIBER_REQUEST_PHARMACY_DETAIL =
  "SUBSCRIBER_REQUEST_PHARMACY_DETAIL";
export const CUSTOMER_VERSION_LIST = "CUSTOMER_VERSION_LIST";
export const CUSTOMER_VERSION_DETAIL = "CUSTOMER_VERSION_DETAIL";
export const CUSTOMER_ENABLE_DISABLE = "CUSTOMER_ENABLE_DISABLE";
export const FETCH_CUSTOMER_HEADQUARTER = "FETCH_CUSTOMER_HEADQUARTER";
export const CUSTOMER_SEND_MAIL = "CUSTOMER_SEND_MAIL";
export const CUSTOMER_DIVISION_LIST = "CUSTOMER_DIVISION_LIST";
export const CUSTOMER_DIVISION_FEILD_FORCE_LIST =
  "CUSTOMER_DIVISION_FEILD_FORCE_LIST";
export const CUSTOMER_ADD_DIVISION = "CUSTOMER_ADD_DIVISION";
export const CUSTOMER_DELETE_DIVISION = "CUSTOMER_DELETE_DIVISION";
export const CUSTOMER_PRODUCT_OFFER_REQUEST_LIST =
  "CUSTOMER_PRODUCT_OFFER_REQUEST_LIST";
export const PHARMACY_PRODUCT_OFFER_REQUEST_LIST =
  "PHARMACY_PRODUCT_OFFER_REQUEST_LIST";
export const CUSTOMER_PRODUCT_OFFER_REQUEST_VIEW =
  "CUSTOMER_PRODUCT_OFFER_REQUEST_VIEW";
export const PHARMACY_PRODUCT_OFFER_REQUEST_VIEW =
  "PHARMACY_PRODUCT_OFFER_REQUEST_VIEW";
export const PRODUCT_OFFER_REQUEST_LIST = "PRODUCT_OFFER_REQUEST_LIST";
export const PRODUCT_OFFER_REQUEST_UPDATE_LIST =
  "PRODUCT_OFFER_REQUEST_UPDATE_LIST";
export const PRODUCT_OFFER_VALUE = "PRODUCT_OFFER_VALUE";
export const CUSTOMER_PRODUCT_OFFER_REQUEST_APPROVE_REJECT =
  "CUSTOMER_PRODUCT_OFFER_REQUEST_APPROVE_REJECT";
export const PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_REJECT =
  "PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_REJECT";
export const PRODUCT_OFFER_REQUEST_APPROVE_ALL =
  "PRODUCT_OFFER_REQUEST_APPROVE_ALL";
export const PRODUCT_OFFER_REQUEST_REJECT_ALL =
  "PRODUCT_OFFER_REQUEST_REJECT_ALL";
export const PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_ALL =
  "PHARMACY_PRODUCT_OFFER_REQUEST_APPROVE_ALL";
export const PHARMACY_PRODUCT_OFFER_REQUEST_REJECT_ALL =
  "PHARMACY_PRODUCT_OFFER_REQUEST_REJECT_ALL";
export const CUSTOMER_PRODUCT_OFFER_LIST = "CUSTOMER_PRODUCT_OFFER_LIST";
export const PHARMACY_PRODUCT_OFFER_LIST = "PHARMACY_PRODUCT_OFFER_LIST";
export const CUSTOMER_PRODUCT_OFFER_REMOVE = "CUSTOMER_PRODUCT_OFFER_REMOVE";
export const CUSTOMER_PRODUCT_OFFER_ADD = "CUSTOMER_PRODUCT_OFFER_ADD";
export const CUSTOMER_PRODUCT_OFFER_PRODUCTS_LIST =
  "CUSTOMER_PRODUCT_OFFER_PRODUCTS_LIST";
export const CUSTOMER_PRODUCT_OFFER_EDIT = "CUSTOMER_PRODUCT_OFFER_EDIT";
export const PHARMACY_PRODUCT_OFFER_EDIT = "PHARMACY_PRODUCT_OFFER_EDIT";
export const UPDATE_DOCTOR_TYPE = "UPDATE_DOCTOR_TYPE";
export const UPDATE_PHARMACY_TYPE = "UPDATE_PHARMACY_TYPE";
export const DOCTOR_ONBOARD_PRODUCT_LIST = "DOCTOR_ONBOARD_PRODUCT_LIST";
export const PHARMACY_ONBOARD_PRODUCT_LIST = "PHARMACY_ONBOARD_PRODUCT_LIST";
export const CUSTOMER_ADD_PRODUCT_LIST = "CUSTOMER_ADD_PRODUCT_LIST";
export const CUSTOMER_ADD_PRODUCT_OFFER_LIST =
  "CUSTOMER_ADD_PRODUCT_OFFER_LIST";
export const ADD_CUSTOMER_PRODUCT = "ADD_CUSTOMER_PRODUCT";
export const ADD_PHARMACY_PRODUCT = "ADD_PHARMACY_PRODUCT";
export const CUSTOMER_SUBSCRIBER_REQUEST_LIST =
  "CUSTOMER_SUBSCRIBER_REQUEST_LIST";
export const CUSTOMER_SUBSCRIBER_REQUEST_DETAIL =
  "CUSTOMER_SUBSCRIBER_REQUEST_DETAIL";

export const DISTRIBUTOR_LIST = "DISTRIBUTOR_LIST";
export const DISTRIBUTOR_ONBOARDING_LIST = "DISTRIBUTOR_ONBOARDING_LIST";
export const DISTRIBUTOR_DETAIL = "DISTRIBUTOR_DETAIL";
export const DISTRIBUTOR_ORDER_DETAIL = "DISTRIBUTOR_ORDER_DETAIL";
export const ENABLE_DISABLE_DISTRIBUTOR = "ENABLE_DISABLE_DISTRIBUTOR";
export const LINK_DISTRIBUTOR = "LINK_DISTRIBUTOR";
export const LINK_DISTRIBUTOR_LIST = "LINK_DISTRIBUTOR_LIST";

export const MANAGE_ORDER_LIST = "MANAGE_ORDER_LIST";
export const MANAGE_ORDER_DETAIL = "MANAGE_ORDER_DETAIL";

export const FAQ_LIST = "FAQ_LIST";

export const SUPPORT_CREATE = "SUPPORT_CREATE";

export const CREATE_SETTING = "CREATE_SETTING";
export const VIEW_SETTING = "VIEW_SETTING";
export const ACCOUNT_SETTING = "ACCOUNT_SETTING";
export const SETTING_PRIVACY_POLICY_VIEW = " SETTING_PRIVACY_POLICY_VIEW";
export const SETTING_PRIVACY_POLICY_EDIT = "SETTING_PRIVACY_POLICY_EDIT";
export const SETTING_TERMS_CONDTION_VIEW = "SETTING_TERMS_CONDTION_VIEW";
export const SETTING_TERMS_CONDTION_EDIT = "SETTING_TERMS_CONDTION_EDIT";

export const SUPER_USER_PERMISSION_LIST = "SUPER_USER_PERMISSION_LIST";
export const SUPER_USER_LIST = "SUPER_USER_LIST";
export const SUPER_USER_DETAIL = "SUPER_USER_DETAIL";
export const SUPER_USER_CREATE = "SUPER_USER_CREATE";
export const SUPER_USER_EDIT = "SUPER_USER_EDIT";
export const SUPER_USER_DELETE = "SUPER_USER_DELETE";
export const SUPER_USER_VERSION_LIST = "SUPER_USER_VERSION_LIST";
export const SUPER_USER_VERSION_DETAIL = "SUPER_USER_VERSION_DETAIL";
export const PERMISSION_LIST = "PERMISSION_LIST";

export const SUPER_USER_ROLE_LIST = "SUPER_USER_ROLE_LIST";
export const SUPER_USER_ROLE_DETAIL = "SUPER_USER_ROLE_DETAIL";
export const SUPER_USER_ROLE_CREATE = "SUPER_USER_ROLE_CREATE";
export const SUPER_USER_ROLE_EDIT = "SUPER_USER_ROLE_EDIT";
export const SUPER_USER_ROLE_DELETE = "SUPER_USER_ROLE_DELETE";
export const SUPER_USER_ROLE_VERSION_LIST = "SUPER_USER_ROLE_VERSION_LIST";
export const SUPER_USER_ROLE_VERSION_DETAIL = "SUPER_USER_ROLE_VERSION_DETAIL";
export const PERMISSION_ROLE_LIST = "PERMISSION_ROLE_LIST";
export const ROLE_LIST = "ROLE_LIST";

export const CFA_LIST = "CFA_LIST";
export const CREATE_CFA = "CREATE_CFA";
export const EDIT_CFA = "EDIT_CFA";
export const CFA_DETAIL = "CFA_DETAIL";
export const CFA_VERSION_LIST = "CFA_VERSION_LIST";
export const CFA_VERSION_DETAIL = "CFA_VERSION_DETAIL";
export const CFA_HEAD_QUATERS_LIST = "CFA_HEAD_QUATERS_LIST";
export const CFA_DISTRIBUTOR_LIST = "CFA_DISTRIBUTOR_LIST";
export const ENALBE_DISABLE_CFA = "ENALBE_DISABLE_CFA";
export const DELETE_CFA = "DELETE_CFA";
export const SEND_CFA_MAIL = "SEND_CFA_MAIL";

export const DASHBOARD_VIEW = "DASHBOARD_VIEW";
export const ANALYTICAL_REPORT_DOWNLOAD = "ANALYTICAL_REPORT_DOWNLOAD";
export const GRAPH_CARD = "GRAPH_CARD";

export const ANALYTICS_CARD = "ANALYTICS_CARD";

export const INVOICE_VERIFY_LIST = "INVOICE_VERIFY_LIST";
export const INVOICE_VERIFY_DETAIL = "INVOICE_VERIFY_DETAIL";
export const INVOICE_VERIFY = "INVOICE_VERIFY";
export const INVOICE_REUPLOAD = "INVOICE_REUPLOAD";
export const INVOICE_VERIFIED_LIST = "INVOICE_VERIFIED_LIST";
export const INVOICE_PTR_UPDATE = "INVOICE_PTR_UPDATE";

export const AI_VERIFIED_INVOICE_LIST = "AI_VERIFIED_INVOICE_LIST";
export const AI_VERIFIED_INVOICE_DETAIL = "AI_VERIFIED_INVOICE_DETAIL";
export const VERIFIED_INVOICE_LIST = "VERIFIED_INVOICE_LIST";
export const VERIFIED_INVOICE_DETAIL = "VERIFIED_INVOICE_DETAIL";
export const FLAGGED_INVOICE_LIST = "FLAGGED_INVOICE_LIST";
export const FLAGGED_INVOICE_DETAIL = "FLAGGED_INVOICE_DETAIL";
export const PENDING_INVOICE_LIST = "PENDING_INVOICE_LIST";
export const PENDING_INVOICE_DETAIL = "PENDING_INVOICE_DETAIL";
export const REJECTED_INVOICE_LIST = "REJECTED_INVOICE_LIST";
export const REJECTED_INVOICE_DETAIL = "REJECTED_INVOICE_DETAIL";
export const VERIFY_PENDING_INVOICE_DETAIL = "VERIFY_PENDING_INVOICE_DETAIL";
export const REJECT_PENDING_INVOICE_DETAIL = "REJECT_PENDING_INVOICE_DETAIL";
export const PRODUCT_BATCH_PRICING_DROPDOWN = "PRODUCT_BATCH_PRICING_DROPDOWN";
export const UPDATE_PRODUCT_PTR = "UPDATE_PRODUCT_PTR";
export const FLAG_AIVERIFIED_INVOICE_DETAIL = "FLAG_AIVERIFIED_INVOICE_DETAIL";

export const CUSTOMER_VERIFY_LIST = "CUSTOMER_VERIFY_LIST";
export const CUSTOMER_VERIFY_DETAIL = "CUSTOMER_VERIFY_DETAIL";
export const VERIFY_REPORT_MODAL = "VERIFY_REPORT_MODAL";
export const PO_LIST = "PO_LIST";
export const PO_CSV_DOWNLOAD = "PO_CSV_DOWNLOAD";
export const PO_STATE_LIST = "PO_STATE_LIST";
export const PO_DISTRIBUTOR_LIST = "PO_DISTRIBUTOR_LIST";
export const PO_OFFERTYPE_LIST = "PO_OFFERTYPE_LIST";
export const GENERATE_PO = "GENERATE_PO";
export const PO_CSV_MAIL = "PO_CSV_MAIL";
export const PO_VIEW = "PO_VIEW";
